import CryptoJS from "crypto-js";
import D_LocalStorage from "@/assets/js/D_LocalStorage";
const DLS = new D_LocalStorage()
class Users {
    constructor(apiService = null) {
        this.obj_name = 'users';
        this.apiService = apiService; // 將 ApiService 實例儲存為屬性
    }

    // 共用的 API 呼叫方法
    async callApi(method, endpoint, parameter = {}, progressEvent = null) {
        const apiConfig = {
            url: `${this.apiService.url}${this.obj_name}/${endpoint}`,
            parameter,
        };

        return new Promise((resolve) => {
            if (method === 'get') {
                apiConfig.url += `?${this.apiService.getMethodEncryp(parameter)}`;
                this.apiService.getApi({
                    url: apiConfig.url,
                    success: resolve,
                    error: (res) => {
                        console.log('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'post') {
                this.apiService.postApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    progress: (res) => {
                        console.log(res);
                        if (progressEvent) {
                            progressEvent(res);
                        }
                    },
                    error: (res) => {
                        console.log('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'put') {
                this.apiService.putApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    progress: (res) => {
                        console.log(res);
                        if (progressEvent) {
                            progressEvent(res);
                        }
                    },
                    error: (res) => {
                        console.log('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'del') {
                this.apiService.delApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    progress: (res) => {
                        console.log(res);
                        if (progressEvent) {
                            progressEvent(res);
                        }
                    },
                    error: (res) => {
                        console.log('error:', res);
                        resolve(res);
                    },
                });
            }
        });
    }

    isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    checkIsAdmin(){
        const localStorageUserData = DLS.getUserInfoToLocalStorage()
        if (!localStorageUserData){
            return false
        }
        const userData = localStorageUserData ? JSON.parse(localStorageUserData) : null
        if ( !userData ){
            return false
        }
        const clinic = userData.clinic.find(item=>item.clinic_id === userData.com_id)
        const isAdmin = clinic.roles.find(item=> parseInt(item.role_id) === 4 )
        if (!isAdmin){
            return false;
        }
        return true
    }
    checkIsOwner(user_id){
        const localStorageUserData = DLS.getUserInfoToLocalStorage()//localStorage.getItem('dcp-clinic-user')
        if (!localStorageUserData){
            return false
        }
        const userData = localStorageUserData ? JSON.parse(localStorageUserData) : null
        if ( !userData ){
            return false
        }
        if ( user_id !== userData.user_id ){
            return false
        }
        return true
    }

    checkOwnerIsDoctor(){
        const localStorageUserData = DLS.getUserInfoToLocalStorage()//localStorage.getItem('dcp-clinic-user')
        if (!localStorageUserData){
            return false
        }
        const userData = localStorageUserData ? JSON.parse(localStorageUserData) : null
        if ( !userData ){
            return false
        }
        const clinic = userData.clinic.find(item=>item.clinic_id === userData.com_id)
        const isDoctor = clinic.roles.findIndex(item=>item.role_id === 8)
        if ( isDoctor === -1 ){
            return false
        }
        return true
    }

    checkTargetIsDoctor(roles){
        const isDoctor = roles.findIndex(item=>item.role_id === 8)
        if ( isDoctor === -1 ){
            return false
        }
        return true
    }

    // API 方法
    /**
     * 取得等待邀請的帳號列表
     * 
     * @async
     * @param {Object} parameter - 查詢參數
     * @param {number} parameter.com_id - 公司 ID
     * @param {number} parameter.com_type - 公司類型
     * @param {number} parameter.page_size - 每頁筆數
     * @param {number} parameter.st_page - 起始頁
     * @param {number} parameter.end_page - 結束頁
     * @returns {Promise<Object>} 回傳包含結果的物件
     * @returns {number} return.code - 回覆結果碼
     * @returns {string} return.message - 回覆訊息
     * @returns {Object} return.data - 回覆資料
        * @returns {Array} return.data.list - 資料列表
        * @returns {number} return.data.total_count - 總資料筆數
     */
    async getWaitInviteAccByCom(parameter) {
        return this.callApi('get', 'getWaitInviteAccByCom', parameter);
    }

    /**
     * 取得等待邀請的帳號列表
     * 
     * @async
     * @param {Object} parameter - 查詢參數
     * @param {number} parameter.role_id - 角色id
     * @param {number} parameter.get_type - 0:取得全部公司,1:取得所屬公司
     * @param {string} parameter.keyword - 關鍵字
     * @param {number} parameter.com_type - 公司類型
     * @param {number} parameter.page_size - 每頁筆數
     * @param {number} parameter.st_page - 起始頁
     * @param {number} parameter.end_page - 結束頁
     * @returns {Promise<Object>} 回傳包含結果的物件
     * @returns {number} return.code - 回覆結果碼
     * @returns {string} return.message - 回覆訊息
     * @returns {Object} return.data - 回覆資料
        * @returns {Array} return.data.list - 資料列表
        * @returns {number} return.data.total_count - 總資料筆數
     */
    async getAllAccByRoleAndKey(parameter) {
        return this.callApi('get', 'getAllAccByRoleAndKey', parameter);
    }

    /**
     * 使用者 - 新增邀請
     * @async
     * @param {Object} parameter - 查詢參數
     * @param {string} parameter.email - 邀請的email
     * @param {number} parameter.role_id - 邀請的email
     * @returns {Promise<Object>} 回傳包含結果的物件
     * @returns {number} return.code - 回覆結果碼
     * @returns {string} return.message - 回覆訊息
     * @returns {string} return.data - 發送邀請email
     */
    async addInvite(parameter,progressEvent=null) {
        return this.callApi('put', 'addInvite', parameter,progressEvent);
    }

    async getAccById(parameter){
        return this.callApi('get', 'getAccById', parameter);
    }

    async getComById(parameter){
        return this.callApi('get', 'getComById', parameter);
    }

    async updAcc(parameter,progressEvent=null) {
        return this.callApi('put', 'updAcc', parameter,progressEvent);
    }

    async updClinicAcc(parameter,progressEvent=null) {
        return this.callApi('put', 'updClinicAcc', parameter,progressEvent);
    }

    async updCom(parameter,progressEvent=null) {
        return this.callApi('put', 'updCom', parameter,progressEvent);
    }
    async getAccountClinicSwitchClinicByAccountid(parameter,progressEvent=null) {
        return this.callApi('post', 'getAccountClinicSwitchClinicByAccountid', parameter,progressEvent);
    }
    async addClinicAndUpdUser(parameter,progressEvent=null) {
        return this.callApi('put', 'addClinicAndUpdUser', parameter,progressEvent);
    }

    async getUserByEmail(parameter){
        return this.callApi('get', 'getUserByEmail', parameter);
    }

    async upDateFcmToken(currentToken){
        console.log(`upDateFcmToken`)
        console.log(`currentToken=` , currentToken)
        //檢查使用者
        const fmcToken = localStorage.getItem('currentToken')
        console.log(`currentToken=` , currentToken)
        console.log(`fmcToken=` , fmcToken)
        if (!fmcToken) return
        if (currentToken === fmcToken){
            console.log(`currentToken fmcToken 一樣不重複取得`)
            return
        } 
        this.addOrUpdAccountNotifyTokenByIp({
            fcm_token: fmcToken
        })
    }

    async addOrUpdAccountNotifyTokenByIp(parameter,progressEvent=null) {
        return this.callApi('put', 'addOrUpdAccountNotifyTokenByIp', parameter,progressEvent);
    }

    async delAccNotifyToken(parameter,progressEvent=null) {
        return this.callApi('del', 'delAccNotifyToken', parameter,progressEvent);
    }

    async getAccountNotifySettingByTypeIdAcId(parameter){
        return this.callApi('get', 'getAccountNotifySettingByTypeIdAcId', parameter);
    }

    async updAccountNotifySettingByTypeIdAcId(parameter,progressEvent=null) {
        return this.callApi('put', 'updAccountNotifySettingByTypeIdAcId', parameter,progressEvent);
    }

    async getNotifyRecordByReceiverTypeIdComId(parameter,progressEvent=null) {
        return this.callApi('get', 'getNotifyRecordByReceiverTypeIdComId', parameter,progressEvent);
    }

    async getNotifyRecordByReceiverTypeIdComIdWithPage(parameter,progressEvent=null) {
        return this.callApi('get', 'getNotifyRecordByReceiverTypeIdComIdWithPage', parameter,progressEvent);
    }

    async resetPwd(parameter,progressEvent=null) {
        //處理加密
        parameter.pwd = CryptoJS.MD5(parameter.pwd).toString()
        parameter.newPwd = CryptoJS.MD5(parameter.newPwd).toString()
        return this.callApi('put', 'resetPwd', parameter,progressEvent);
    }

    
}

export default Users;
